import * as R from 'ramda';

import { handledDeleteFetch, handledGetFetch, handledPostFetch } from '../../submodules/shared/utils/api-base';

import { PATHS } from './paths';
import { buildUrl } from './url';

export const getLabItems = ({ orderBy, dir, where = {}, limit, offset }) =>
    handledGetFetch(buildUrl(PATHS.labs, { order_by: orderBy, dir, product_id: where.product_id, limit, offset }));

export const getLabDetails = (id) => handledGetFetch(buildUrl(PATHS.lab(id)));

export const postLabDetails = (payload) => handledPostFetch(buildUrl(PATHS.lab(R.propOr('', 'id', payload))), payload);

export const deleteLabDetails = (id) => handledDeleteFetch(buildUrl(PATHS.lab(id)));

export const getLabInstructions = (labId) => handledGetFetch(buildUrl(PATHS.labInstructions(labId)));

export const postLabKeys = (payload) => handledPostFetch(buildUrl(PATHS.labKeys), payload);

export const getLabsByProduct = ({ product, start, type }) =>
    handledGetFetch(buildUrl(PATHS.labs, { product_id: product, start_date: start, event_type: type }));
